import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { PortalUser } from "@/types";

// Portal-Admins (nie Hash).
export function usePortalUsers(): UseQueryResult<PortalUser[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("portal-users"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<PortalUser[]>("/auth/users");
    },
    enabled: !!session,
  });
}
